stableStringify